import React from 'react';
import { Tabs } from '@common/components';
import clsx from 'clsx';

type DrawerTabsTabType = {
  title: string;
  content: JSX.Element;
};

export function DrawerTabs({
  tabs = [],
  className,
}: {
  tabs?: DrawerTabsTabType[];
  className?: string;
}) {
  if (!tabs.length) {
    return null;
  }

  const hasMoreThanOneTab = tabs.length > 1;

  return (
    <div className={clsx('wk-drawer-tabs', className)}>
      {!hasMoreThanOneTab ? (
        tabs[0].content
      ) : (
        <Tabs style={{ height: '100%' }} stickyHeader>
          {tabs.map((tab) => (
            <Tabs.Pane
              key={tab.title}
              tab={tab.title}
              style={{ height: '100%' }}
            >
              <div className="wk-drawer-tabs-content">{tab.content}</div>
            </Tabs.Pane>
          ))}
        </Tabs>
      )}

      <style jsx>{`
        .wk-drawer-tabs,
        .wk-drawer-tabs-content,
        .wk-drawer-tabs :global(.Tabs),
        .wk-drawer-tabs :global(.ant-tabs-content) {
          height: 100%;
        }
        .wk-drawer-tabs {
          margin-top: -12px;
        }
        .wk-drawer-tabs-content {
          padding-top: 24px;
        }
      `}</style>
    </div>
  );
}
